import {get} from 'lodash-es';

const DEFAULT_EMPTY_LIST = [];

export const getContentHides = (state) => get(state, 'contentHides.items', DEFAULT_EMPTY_LIST);
